import { render, staticRenderFns } from "./SupsisLogoPurple.vue?vue&type=template&id=1c822364&scoped=true"
import script from "./SupsisLogoPurple.vue?vue&type=script&lang=js"
export * from "./SupsisLogoPurple.vue?vue&type=script&lang=js"
import style0 from "./SupsisLogoPurple.vue?vue&type=style&index=0&id=1c822364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c822364",
  null
  
)

export default component.exports